import React, { createContext, useEffect, useState, useContext } from 'react';
import $ from 'jquery';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import {
  getDate,
  getMonth,
  getYear,
  isBefore,
  isValid,
  intervalToDuration,
  parseISO,
  format
} from 'date-fns';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBRLocale from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import Toast from '../../../../components/Toast';
import { options } from '../../../../helpers/toastOptions';
import { Header } from '../../../../components/Header';
import SearchResult from './components/SearchResult';
import { useAuth } from '../../../../hooks/Auth';
import { useIntegration } from '../../../../hooks/Integration';
import { useManager } from '../../../../hooks/Manager';
import { useTracking } from '../../../../hooks/Tracking';
import { parseCpfCnpj } from '../../../../helpers/parseValues';
import { useModal } from '../../../../hooks/Modal';
import { ModalLoading } from '../../../../components/ModalLoading';
import { ModalCancel } from './components/ModalCancel';
import { ModalCancelPickup } from './components/ModalCancelPickup';
import { ModalCancelMultiple } from './components/ModalCancelMultiple';
import { ModalChooseCancelMethod } from './components/ModalChooseCancelMethod';
import { ModalExtend } from './components/ModalExtend';
import { ModalExtendPickup } from './components/ModalExtendPickup';
import { ModalExtendMultiple } from './components/ModalExtendMultiple';
import { ModalChooseExtensionMethod } from './components/ModalChooseExtensionMethod';
import { ModalDownloadDocuments } from './components/ModalDownloadDocuments';
import { ModalDownloadInvoices } from './components/ModalDownloadInvoices';
import { ModalUploadDocuments } from './components/ModalUploadDocuments';
import { ModalUploadInvoices } from './components/ModalUploadInvoices';
import { ModalPrintTag } from './components/ModalPrintTag';

import { Container, Content, Route, Title } from './styled';

export const SearchMyCollectionsContext = createContext({});

const SearchMyCollections = () => {
  const { openModal, openedModal } = useModal();
  const [transportTypeList, setTransportTypeList] = useState([]);
  const [pickupTypeList, setPickupTypeList] = useState([]);
  const [pickupStatusList, setPickupStatusList] = useState([]);
  const [searchDateFrom, setSearchDateFrom] = useState('');
  const [searchDateTo, setSearchDateTo] = useState('');
  const [documentSender, setDocumentSender] = useState('');
  const [documentRecipient, setDocumentRecipient] = useState('');
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [currentPageState, setCurrentPageState] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('protocolo');
  const [isSubmittingPagination, setIsSubmittingPagination] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [pickupDetailList, setPickupDetailList] = useState([]);
  const [isLoadingPickupDetails, setIsLoadingPickupDetails] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [disableCancelButton, setDisableCancelButton] = useState(true);
  const [extensionReasonList, setExtensionReasonList] = useState([]);
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [openOtherExtensionToFill, setOpenOtherExtensionToFill] =
    useState(true);
  const [openOtherCancelToFill, setOpenOtherCancelToFill] = useState(true);
  const [protocolToModal, setProtocolToModal] = useState('');
  const [pickupIdToModal, setPickupIdToModal] = useState('');
  const [branchParameterizationToModal, setBranchParameterizationToModal] =
    useState('');
  const [dataToExtend, setDataToExtend] = useState({});
  const [dataToCancelInvoice, setDataToCancelInvoice] = useState({});
  const [modalMessage, setModalMessage] = useState('');
  const [invoiceListToModal, setInvoiceListToModal] = useState([]);
  const [zipToModal, setZipToModal] = useState('');
  const [uploadConfigToModal, setUploadConfigToModal] = useState({});
  const [downloadConfigToModal, setDownloadConfigToModal] = useState({});
  const [documentListToDownload, setDocumentListToDownload] = useState([]);
  const [invoiceListToDownload, setInvoiceListToDownload] = useState([]);
  const [viewSearchFrom, setViewSearchFrom] = useState(true);
  const [viewSearchTo, setViewSearchTo] = useState(true);
  const [viewSearchPickupType, setViewSearchPickupType] = useState(true);
  const [viewClientInternalCode, setViewClientInternalCode] = useState(true);
  const [viewSearchPickupStatus, setViewSearchPickupStatus] = useState(true);
  const [viewSearchModal, setViewSearchModal] = useState(true);
  const [viewKnowledgeNumber, setViewKnowledgeNumber] = useState(true);
  const [viewProtocol, setViewProtocol] = useState(true);
  const [viewTaxDocumentNumber, setViewTaxDocumentNumber] = useState(true);
  const [viewDocumentRecipient, setViewDocumentRecipient] = useState(true);
  const [viewDocumentRecipientGroup, setViewDocumentRecipientGroup] =
    useState(true);
  const [viewDocumentSender, setViewDocumentSender] = useState(true);
  const [viewDocumentSenderGroup, setViewDocumentSenderGroup] = useState(true);
  const [lastSearch, setLastSearch] = useState({});
  const [limitToUploadInvoice, setLimitToUploadInvoice] = useState(0);
  const [isPickupWithDeclaration, setIsPickupWithDeclaration] = useState(false);
  const [isSearchingDocument, setIsSearchingDocument] = useState(false);
  const [hasInvalidRecipientDocument, setHasInvalidRecipientDocument] =
    useState(false);
  const [hasInvalidSenderDocument, setHasInvalidSenderDocument] =
    useState(false);
  const [protocolExtend, setProtocolExtend] = useState('');
  const [protocolExtendAll, setProtocolExtendAll] = useState({});
  const [isToRefreshSearch, setIsToRefreshSearch] = useState(false);
  const [enablePickupOnWeekends, setEnablePickupOnWeekends] = useState(false);
  const [hourLimitOnWeekends, setHourLimitOnWeekends] = useState(0);
  const [enablePickupOnHolidays, setEnablePickupOnHolidays] = useState(false);
  const [hourLimitOnHolidays, setHourLimitOnHolidays] = useState(0);
  const [enableSlotTimeToPickupSchedule, setEnableSlotTimeToPickupSchedule] =
    useState(false);
  const [hourSlotTimeToPickupSchedule, setSlotTimeToPickupSchedule] =
    useState(0);
  const [minuteSlotTimeToPickupSchedule, setMinuteSlotTimeToPickupSchedule] =
    useState(0);

  const { searchUser, getBranchList } = useIntegration();
  const {
    GetAllTransportType,
    GetAllPickupStatus,
    GetAllPickupType,
    getBranchFilters,
    getPickupManagerParameterization
  } = useManager();
  const { filterPickup } = useTracking();

  const maxXS = useMediaQuery('(max-width:480px)');
  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const searchSchema = Yup.object().shape({});

  // release

  const {
    handleSubmit,
    control,
    setValue,
    setError,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: yupResolver(searchSchema),
    mode: 'all',
    reValidateMode: 'onChange'
  });

  useEffect(() => {
    if (protocolExtend) {
      setValue('searchFrom', '');
      setValue('searchTo', '');
      setValue('searchPickupType', '');
      setValue('clientInternalCode', '');
      setValue('searchPickupStatus', '');
      setValue('searchModal', '');
      setValue('knowledgeNumber', '');
      setValue('taxDocumentNumber', '');
      setValue('documentRecipient', '');
      setValue('searchNameRecipient', '');
      setValue('documentSender', '');
      setValue('searchNameSender', '');
      setValue('protocol', protocolExtend);
      setSearchDateTo(null);
      setSearchDateFrom(null);
      setDocumentSender('');
      setDocumentRecipient('');
      // setProtocolExtend('');
    }
  }, [protocolExtend]);

  const onSubmit = async (data) => {
    if (hasInvalidRecipientDocument || hasInvalidSenderDocument) {
      toast(
        <Toast
          title="Atenção!"
          content="CNPJ/ CPF não cadastrado. Favor verificar."
          type="error"
        />,
        options
      );

      return;
    }
    let requestObject = {};

    if (!data.isRefreshSearch) {
      if (
        !(
          data.protocol ||
          data.taxDocumentNumber ||
          data.knowledgeNumber ||
          data.clientInternalCode
        ) &&
        (!data.searchFrom || data.searchFrom === '')
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="O campo “Data – Período de” deve ser preenchido para prosseguir com a pesquisa."
            type="error"
          />,
          options
        );

        setError('searchFrom', { message: 'Data obrigatória' });

        return;
      }

      if (
        data.searchFrom &&
        (!isValid(new Date(data.searchFrom)) ||
          format(new Date(data.searchFrom), 'yyyy')?.replace(/^0+/, '')
            ?.length < 4)
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="Para realizar a consulta é necessário informar um período válido."
            type="error"
          />,
          options
        );

        setError('searchFrom', { message: 'Data inválida' });

        return;
      }

      if (
        !(
          data.protocol ||
          data.taxDocumentNumber ||
          data.knowledgeNumber ||
          data.clientInternalCode
        ) &&
        (!data.searchTo || data.searchTo === '')
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="O campo “Data – Período a” deve ser preenchido para prosseguir com a pesquisa."
            type="error"
          />,
          options
        );

        setError('searchTo', { message: 'Data obrigatória' });

        return;
      }

      if (
        data.searchTo &&
        (!isValid(new Date(data.searchTo)) ||
          format(new Date(data.searchTo), 'yyyy')?.replace(/^0+/, '')?.length <
            4)
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="Para realizar a consulta é necessário informar um período válido."
            type="error"
          />,
          options
        );

        setError('searchTo', { message: 'Data inválida' });

        return;
      }

      if (data.searchFrom && data.searchTo) {
        if (isBefore(new Date(data.searchTo), new Date(data.searchFrom))) {
          toast(
            <Toast
              title="Atenção!"
              content="Para realizar a consulta é necessário informar um período válido."
              type="error"
            />,
            options
          );

          setError('searchTo', { message: 'Data inválida' });

          return;
        }

        const interval = intervalToDuration({
          start: new Date(data.searchFrom),
          end: new Date(data.searchTo)
        });

        if ((interval.months > 0 && interval.days > 0) || interval.months > 1) {
          toast(
            <Toast
              title="Atenção!"
              content="Para realizar a consulta é necessário informar um período válido com intervalo máximo de 30 dias."
              type="error"
            />,
            options
          );

          setError('searchTo', { message: 'Data inválida' });

          return;
        }
      }

      if (data.searchFrom) {
        const startDate = new Date(data.searchFrom).toISOString();

        requestObject.startDate = `${startDate.split('T')[0]}T00:00:00.000Z`;
      }

      if (data.searchTo) {
        const endDate = new Date(data.searchTo).toISOString();

        requestObject.endDate = `${endDate.split('T')[0]}T23:59:59.000Z`;
      }

      if (data.protocol) {
        requestObject.protocol = data.protocol;
      }

      if (data.searchPickupStatus) {
        requestObject.requestStatus = data.searchPickupStatus;
      }

      if (data.searchPickupType) {
        requestObject.collectionType = data.searchPickupType;
      }

      if (data.searchBranchFrom) {
        requestObject.subsidiaryOrigin = data.searchBranchFrom;
      }

      if (data.searchBranchTo) {
        requestObject.subsidiaryDestination = data.searchBranchTo;
      }

      if (data.searchModal) {
        requestObject.modalType = data.searchModal;
      }

      if (data.taxDocumentNumber) {
        requestObject.invoiceNumber = data.taxDocumentNumber;
      }

      if (data.clientInternalCode) {
        requestObject.clientInternalCode = data.clientInternalCode;
      }

      if (data.knowledgeNumber) {
        requestObject.knowledgeId = data.knowledgeNumber;
      }

      if (data.documentRecipient) {
        requestObject.receiverDocument = parseCpfCnpj(data.documentRecipient);
      }

      if (data.documentSender) {
        requestObject.senderDocument = parseCpfCnpj(data.documentSender);
      }

      requestObject.currentPage = 1;

      requestObject.pageSize = rowsPerPage;

      requestObject.sortField = orderBy;

      requestObject.order = order;
    } else {
      requestObject = protocolExtend
        ? { protocol: protocolExtend }
        : lastSearch;

      requestObject.currentPage = protocolExtend ? 1 : page;

      requestObject.pageSize = rowsPerPage;

      requestObject.sortField = orderBy;

      requestObject.order = order;
    }

    try {
      setRows([]);
      setPickupDetailList([]);
      setIsSearching(true);
      setZipToModal('');
      setPickupIdToModal('');
      setLastSearch(requestObject);

      const pickupList = await filterPickup({
        params: requestObject
      });

      if (pickupList) {
        const { records, currentPage } = pickupList;

        if (records?.length > 0) {
          const list = [];

          const newPickupDetailList = [];

          records.forEach((pickup) => {
            newPickupDetailList.push({ isOpen: false, pickup: {} });
            const { createdAt, transportTypeId } = pickup;

            const day = String(getDate(parseISO(createdAt))).padStart(2, '0');
            const month = String(getMonth(parseISO(createdAt)) + 1).padStart(
              2,
              '0'
            );
            const year = getYear(parseISO(createdAt));

            const newCreationDate = `${day}/${month}/${year}`;

            const modal = transportTypeId === 1 ? 'Rodoviário' : 'Rodoaéreo';

            list.push({
              modal,
              formattedCreatedAt: newCreationDate,
              ...pickup
            });
          });

          setPage(currentPage);
          setTotalRecords(pickupList.totalRecords);
          setTotalPages(pickupList.totalPages);

          setRows(list);
          setProtocolExtend('');
          setPickupDetailList(newPickupDetailList);
        } else if (documentRecipient || documentSender) {
          toast(
            <Toast
              title="Atenção!"
              content="CNPJ/CPF não cadastrado. Favor verificar."
              type="error"
            />,
            options
          );
        } else {
          toast(
            <Toast
              title="Atenção!"
              content="Não foram localizados registros para esta pesquisa."
              type="error"
            />,
            options
          );

          setPage(1);
          setTotalRecords(0);
          setTotalPages(1);
        }
      } else {
        toast(
          <Toast
            title="Atenção!"
            content="Não foram localizados registros para esta pesquisa."
            type="error"
          />,
          options
        );

        setPage(1);
        setTotalRecords(0);
        setTotalPages(1);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    setIsSearching(false);
  };

  const getDocumentInfo = async (value, entity) => {
    if (value) {
      setIsSearchingDocument(true);

      try {
        const localToken = localStorage.getItem('@Braspress:token');

        const userSearched = await searchUser({
          searchData: { document: parseCpfCnpj(value) },
          token: localToken
        });

        if (userSearched?.length > 0) {
          const { name } = userSearched[0];

          setValue(`searchName${entity}`, name.toUpperCase());

          if (entity === 'Recipient') {
            setHasInvalidRecipientDocument(false);
          } else {
            setHasInvalidSenderDocument(false);
          }
        } else {
          if (entity === 'Recipient') {
            setHasInvalidRecipientDocument(true);
          } else {
            setHasInvalidSenderDocument(true);
          }

          toast(
            <Toast
              title="Atenção!"
              content="CNPJ/ CPF não cadastrado. Favor verificar."
              type="error"
            />,
            options
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      } finally {
        setIsSearchingDocument(false);
      }
    } else if (entity === 'Recipient') {
      setHasInvalidRecipientDocument(false);
    } else {
      setHasInvalidSenderDocument(false);
    }
  };

  const handleRedirectToMyAccount = () => {
    // window.location.href = `${process.env.REACT_APP_URL_CLIENT_VIEW}${process.env.REACT_APP_URL_BOTAO_VOLTAR}`;
    window.history.go(-2);
  };

  const refreshSearch = () => {
    setIsToRefreshSearch(true);
  };

  const openLoadingModal = () => {
    openModal('modalLoading');
  };

  const openDownloadDocumentsModal = () => {
    openModal('modalDownloadDocuments');
  };

  const openDownloadInvoicesModal = () => {
    openModal('modalDownloadInvoices');
  };

  const openUploadDocumentsModal = () => {
    openModal('modalUploadDocuments');
  };

  const openUploadInvoicesModal = () => {
    openModal('modalUploadInvoices');
  };

  const openPrintTagModal = () => {
    openModal('modalPrintTag');
  };

  const openExtendPickupModal = () => {
    openModal('modalExtend');
  };

  const openExtendPickupNoInvoiceModal = () => {
    openModal('modalExtendPickup');
  };

  const openExtendMultipleModal = () => {
    openModal('modalExtendMultiple');
  };

  const openChooseExtensionMethodModal = () => {
    openModal('modalChooseExtensionMethod');
  };

  const openCancelPickupModal = () => {
    openModal('modalCancel');
  };

  const openCancelPickupNoInvoiceModal = () => {
    openModal('modalCancelPickup');
  };

  const openCancelMultipleModal = () => {
    openModal('modalCancelMultiple');
  };

  const openChooseCancelMethodModal = () => {
    openModal('modalChooseCancelMethod');
  };

  const onComponentDidMount = async () => {
    try {
      const transportList = await GetAllTransportType();
      const pickupType = await GetAllPickupStatus();
      const pickupStatus = await GetAllPickupType();

      setTransportTypeList(transportList);
      setPickupTypeList(pickupType);
      setPickupStatusList(pickupStatus);

      const pickupManagerResponse = await getPickupManagerParameterization({
        branchId: 1,
        transportTypeId: 9,
        pickupTypeId: 1,
        inputTypeId: 5
      });

      if (pickupManagerResponse.length > 0) {
        const branch = await getBranchList();

        if (branch?.length > 0) {
          setBranchList(branch);
        }

        const filtersList = await getBranchFilters({
          branchParameterizationId:
            pickupManagerResponse[0].branchParameterizationId
        });

        setViewSearchFrom(filtersList[0].enabled);
        setViewSearchTo(filtersList[1].enabled);
        setViewSearchPickupStatus(filtersList[2].enabled);
        setViewProtocol(filtersList[3].enabled);
        setViewClientInternalCode(filtersList[4].enabled);
        setViewTaxDocumentNumber(filtersList[5].enabled);
        setViewKnowledgeNumber(filtersList[6].enabled);
        setViewSearchModal(filtersList[7].enabled);
        setViewSearchPickupType(filtersList[8].enabled);
        setViewDocumentRecipientGroup(filtersList[9].enabled);
        setViewDocumentRecipient(filtersList[10].enabled);
        setViewDocumentSenderGroup(filtersList[11].enabled);
        setViewDocumentSender(filtersList[12].enabled);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#documentSender').mask(cpf.length > 14 ? masks[1] : masks[0], op);
      }
    };

    $('#documentSender').length > 11
      ? $('#documentSender').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#documentSender').mask('000.000.000-00#', cpfCnpjOptions);
  }, [documentSender]);

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#documentRecipient').mask(cpf.length > 14 ? masks[1] : masks[0], op);
      }
    };

    $('#documentRecipient').length > 11
      ? $('#documentRecipient').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#documentRecipient').mask('000.000.000-00#', cpfCnpjOptions);
  }, [documentRecipient]);

  useEffect(() => {
    onComponentDidMount();
  }, []);

  useEffect(() => {
    if (isToRefreshSearch || isSubmittingPagination) {
      onSubmit({
        isRefreshSearch: isToRefreshSearch || isSubmittingPagination
      });
      setIsToRefreshSearch(false);
      setIsSubmittingPagination(false);
    }
  }, [isToRefreshSearch, isSubmittingPagination, totalPages, totalRecords]);

  const contextValues = {
    rows,
    setRows,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    totalRecords,
    setTotalRecords,
    totalPages,
    setTotalPages,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    isSubmittingPagination,
    setIsSubmittingPagination,
    pickupDetailList,
    setPickupDetailList,
    isLoadingPickupDetails,
    setIsLoadingPickupDetails,
    isSearching,
    setIsSearching,
    transportTypeList,
    setTransportTypeList,
    extensionReasonList,
    setExtensionReasonList,
    cancelReasonList,
    setCancelReasonList,
    openOtherExtensionToFill,
    setOpenOtherExtensionToFill,
    openOtherCancelToFill,
    setOpenOtherCancelToFill,
    disableCancelButton,
    setDisableCancelButton,
    protocolToModal,
    setProtocolToModal,
    pickupIdToModal,
    setPickupIdToModal,
    branchParameterizationToModal,
    setBranchParameterizationToModal,
    dataToExtend,
    setDataToExtend,
    dataToCancelInvoice,
    setDataToCancelInvoice,
    modalMessage,
    setModalMessage,
    invoiceListToModal,
    setInvoiceListToModal,
    zipToModal,
    setZipToModal,
    documentListToDownload,
    setDocumentListToDownload,
    invoiceListToDownload,
    setInvoiceListToDownload,
    uploadConfigToModal,
    setUploadConfigToModal,
    downloadConfigToModal,
    setDownloadConfigToModal,
    refreshSearch,
    openLoadingModal,
    openDownloadDocumentsModal,
    openDownloadInvoicesModal,
    openUploadDocumentsModal,
    openUploadInvoicesModal,
    openPrintTagModal,
    openExtendPickupModal,
    openExtendPickupNoInvoiceModal,
    openExtendMultipleModal,
    openChooseExtensionMethodModal,
    openCancelPickupModal,
    openCancelPickupNoInvoiceModal,
    openCancelMultipleModal,
    openChooseCancelMethodModal,
    limitToUploadInvoice,
    setLimitToUploadInvoice,
    isPickupWithDeclaration,
    setIsPickupWithDeclaration,
    protocolExtend,
    setProtocolExtend,
    protocolExtendAll,
    setProtocolExtendAll,
    isToRefreshSearch,
    setIsToRefreshSearch,
    enablePickupOnWeekends,
    setEnablePickupOnWeekends,
    enablePickupOnHolidays,
    setEnablePickupOnHolidays,
    hourLimitOnWeekends,
    setHourLimitOnWeekends,
    hourLimitOnHolidays,
    setHourLimitOnHolidays,
    enableSlotTimeToPickupSchedule,
    setEnableSlotTimeToPickupSchedule,
    hourSlotTimeToPickupSchedule,
    setSlotTimeToPickupSchedule,
    minuteSlotTimeToPickupSchedule,
    setMinuteSlotTimeToPickupSchedule
  };

  return (
    <SearchMyCollectionsContext.Provider value={contextValues}>
      <Container>
        {/* <Header /> */}
        <Content>
          <Stack
            spacing={3}
            style={{ margin: '0 40px', paddingBottom: '40px' }}
          >
            {/* <Route>
              {!maxSM && (
                <>
                  Home {'>'} Área do Cliente {'>'} Minha Conta {'>'} Minhas
                  Coletas
                </>
              )}

              {!!user && (
                <Stack
                  direction="row"
                  spacing={2}
                  style={{
                    alignItems: 'center',
                    marginLeft: maxSM && 'auto'
                  }}
                >
                  <p>{user.name}</p>
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={signOut}
                    size="small"
                  >
                    Sair
                  </Button>
                </Stack>
              )}
            </Route> */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <Paper
                elevation={2}
                style={{
                  position: 'relative',
                  marginTop: 16,
                  padding: '20px 16px 16px'
                }}
              >
                <Title style={{ marginBottom: 16 }}>Pesquisar:</Title>

                <Stack spacing={2}>
                  <Stack spacing={2} direction={maxMD ? 'column' : 'row'}>
                    <Controller
                      name="searchFrom"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          locale={ptBRLocale}
                        >
                          <DatePicker
                            name="searchFrom"
                            label="Período de"
                            mask="__/__/____"
                            {...field}
                            value={searchDateFrom}
                            onChange={(e) => {
                              setSearchDateFrom(e);
                              field.onChange(e);
                            }}
                            disabled={!!isSearching || !viewSearchFrom}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                {...params}
                                onBlur={(event) => {
                                  if (
                                    event?.target?.value?.length >= 8 &&
                                    event?.target?.value?.length < 10
                                  ) {
                                    const [day, month, year] =
                                      event.target.value.split('/');

                                    const newDate = new Date(
                                      `20${year?.replace(/^0+/, '')}`,
                                      month - 1,
                                      day
                                    );

                                    setSearchDateFrom(newDate);
                                    setValue('searchFrom', newDate);
                                  }
                                }}
                                inputProps={{
                                  ...params.inputProps,
                                  placeholder: 'DD/MM/AAAA'
                                }}
                                name="searchFrom"
                                error={!!errors.searchFrom}
                                helperText={errors.searchFrom?.message}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      )}
                    />

                    <Controller
                      name="searchTo"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          locale={ptBRLocale}
                        >
                          <DatePicker
                            name="searchTo"
                            label="Período a"
                            mask="__/__/____"
                            {...field}
                            value={(field.value = searchDateTo)}
                            onChange={(e) => {
                              setSearchDateTo(e);
                              field.onChange(e);
                            }}
                            disabled={!!isSearching || !viewSearchTo}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                {...params}
                                onBlur={(event) => {
                                  if (
                                    event?.target?.value?.length >= 8 &&
                                    event?.target?.value?.length < 10
                                  ) {
                                    const [day, month, year] =
                                      event.target.value.split('/');

                                    const newDate = new Date(
                                      `20${year?.replace(/^0+/, '')}`,
                                      month - 1,
                                      day
                                    );

                                    setSearchDateTo(newDate);
                                    setValue('searchTo', newDate);
                                  }
                                }}
                                inputProps={{
                                  ...params.inputProps,
                                  placeholder: 'DD/MM/AAAA'
                                }}
                                name="searchTo"
                                error={!!errors.searchTo}
                                helperText={errors.searchTo?.message}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      )}
                    />

                    <Controller
                      name="searchPickupType"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          disabled={
                            !!isSearching ||
                            !searchDateFrom ||
                            !searchDateTo ||
                            !viewSearchPickupType
                          }
                          error={!!errors.searchPickupType}
                          style={{ width: '100%' }}
                        >
                          <InputLabel>Tipo de Coleta</InputLabel>
                          <Select
                            id="searchPickupType"
                            label="Tipo de Coleta"
                            {...field}
                            error={!!errors.searchPickupType}
                          >
                            <MenuItem value="" style={{ height: 36 }} />
                            {pickupStatusList.map(
                              ({ description, pickup_Type_Id }) => (
                                <MenuItem
                                  key={pickup_Type_Id}
                                  value={pickup_Type_Id}
                                >
                                  {description}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Stack>

                  <Stack spacing={2} direction={maxMD ? 'column' : 'row'}>
                    <Controller
                      name="clientInternalCode"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Código Interno Cliente"
                          name="clientInternalCode"
                          fullWidth
                          {...field}
                          value={field.value}
                          onChange={(e) => {
                            const regex = /^[aA-zZ0-9\s]+$/;
                            if (
                              !e.target.value.match(regex) &&
                              e.target.value !== ''
                            ) {
                              return;
                            }
                            field.onChange(e.target.value);
                          }}
                          error={!!errors.clientInternalCode}
                          helperText={errors.clientInternalCode?.message}
                          disabled={!!isSearching || !viewClientInternalCode}
                        />
                      )}
                    />

                    <Controller
                      name="searchPickupStatus"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          fullWidth
                          error={!!errors.searchPickupStatus}
                          disabled={
                            !!isSearching ||
                            !searchDateFrom ||
                            !searchDateTo ||
                            !viewSearchPickupStatus
                          }
                        >
                          <InputLabel>Status da Coleta</InputLabel>
                          <Select
                            id="searchPickupStatus"
                            label="Status da Coleta"
                            {...field}
                            error={!!errors.searchPickupStatus}
                          >
                            <MenuItem value="" style={{ height: 36 }} />
                            {pickupTypeList.map(
                              ({ description, pickup_Status_Id }) => (
                                <MenuItem
                                  key={pickup_Status_Id}
                                  value={pickup_Status_Id}
                                >
                                  {description}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      )}
                    />

                    <Controller
                      name="searchModal"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          disabled={
                            !!isSearching ||
                            !searchDateFrom ||
                            !searchDateTo ||
                            !viewSearchModal
                          }
                          error={!!errors.searchModal}
                          style={{ width: '100%' }}
                        >
                          <InputLabel>Tipo de Modal</InputLabel>
                          <Select
                            id="searchModal"
                            label="Tipo de Modal"
                            {...field}
                            error={!!errors.searchModal}
                          >
                            <MenuItem value="" style={{ height: 36 }} />
                            {transportTypeList.map(
                              ({ description, transport_Type_Id }) => (
                                <MenuItem
                                  key={transport_Type_Id}
                                  value={transport_Type_Id}
                                >
                                  {description}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Stack>

                  <Stack spacing={2} direction={maxMD ? 'column' : 'row'}>
                    <Controller
                      name="knowledgeNumber"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Conhecimento"
                          name="knowledgeNumber"
                          fullWidth
                          {...field}
                          error={!!errors.knowledgeNumber}
                          helperText={errors.knowledgeNumber?.message}
                          value={field.value}
                          onChange={(e) => {
                            const regex = /^[aA-zZ0-9\s]+$/;
                            if (
                              !e.target.value.match(regex) &&
                              e.target.value !== ''
                            ) {
                              return;
                            }
                            field.onChange(e.target.value);
                          }}
                          disabled={!!isSearching || !viewKnowledgeNumber}
                        />
                      )}
                    />

                    <Controller
                      name="protocol"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Protocolo"
                          name="protocol"
                          fullWidth
                          {...field}
                          value={field.value}
                          onChange={(e) => {
                            const regex = /^[aA-zZ0-9\s]+$/;
                            if (
                              !e.target.value.match(regex) &&
                              e.target.value !== ''
                            ) {
                              return;
                            }
                            field.onChange(e.target.value.toUpperCase());
                            setValue('protocol', e.target.value.toUpperCase());
                          }}
                          inputProps={{ ...field.inputProps, maxLength: 19 }}
                          error={!!errors.protocol}
                          // helperText={errors.protocol?.message}
                          disabled={!!isSearching || !viewProtocol}
                        />
                      )}
                    />

                    <Controller
                      name="taxDocumentNumber"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Número da NF"
                          name="taxDocumentNumber"
                          fullWidth
                          {...field}
                          value={field.value}
                          onChange={(e) => {
                            const regex = /^[0-9]+$/;
                            if (
                              !e.target.value.match(regex) &&
                              e.target.value !== ''
                            ) {
                              return;
                            }
                            field.onChange(e.target.value);
                          }}
                          inputProps={{ maxLength: 10 }}
                          error={!!errors.taxDocumentNumber}
                          helperText={errors.taxDocumentNumber?.message}
                          disabled={!!isSearching || !viewTaxDocumentNumber}
                        />
                      )}
                    />
                  </Stack>

                  <Stack spacing={2} direction={maxMD ? 'column' : 'row'} />

                  {!viewDocumentRecipientGroup ? null : (
                    <>
                      <Title>Pesquisa por dados do Destinatário:</Title>
                      <Stack spacing={2} direction={maxMD ? 'column' : 'row'}>
                        <Controller
                          name="documentRecipient"
                          id="documentRecipient"
                          defaultValue=""
                          control={control}
                          render={({ field }) => (
                            <TextField
                              name="documentRecipient"
                              id="documentRecipient"
                              label="CNPJ/CPF Destinatário"
                              {...field}
                              style={{ width: '100%' }}
                              error={!!errors.documentRecipient}
                              helperText={errors.documentRecipient?.message}
                              value={(field.value = documentRecipient)}
                              onChange={(e) => {
                                setValue('searchNameRecipient', '');
                                setDocumentRecipient(e.target.value);
                                field.onChange(e.target.value);
                              }}
                              onBlur={(e) => {
                                const { value } = e.target;
                                getDocumentInfo(value, 'Recipient');
                                setDocumentRecipient(e.target.value);
                                field.onBlur(field.onChange(value));
                              }}
                              disabled={
                                !!isSearching ||
                                !searchDateFrom ||
                                !searchDateTo ||
                                !viewDocumentRecipient
                              }
                            />
                          )}
                        />
                        <Controller
                          name="searchNameRecipient"
                          defaultValue=""
                          control={control}
                          render={({ field }) => (
                            <TextField
                              name="searchNameRecipient"
                              label="Razão Social/Nome Destinatário"
                              disabled
                              {...field}
                              style={{ width: '100%' }}
                              error={!!errors.searchNameRecipient}
                              helperText={errors.searchNameRecipient?.message}
                            />
                          )}
                        />
                      </Stack>
                    </>
                  )}

                  <Stack spacing={2}>
                    {!viewDocumentSenderGroup ? null : (
                      <>
                        <Title>Pesquisa por dados do Remetente:</Title>
                        <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
                          <Controller
                            id="documentSender"
                            name="documentSender"
                            defaultValue=""
                            control={control}
                            render={({ field }) => (
                              <TextField
                                name="documentSender"
                                id="documentSender"
                                label="CNPJ/CPF Remetente"
                                {...field}
                                style={{ width: '100%' }}
                                error={!!errors.documentSender}
                                helperText={errors.documentSender?.message}
                                value={(field.value = documentSender)}
                                onChange={(e) => {
                                  setValue('searchNameSender', '');
                                  setDocumentSender(e.target.value);
                                  field.onChange(e.target.value);
                                }}
                                onBlur={(e) => {
                                  const { value } = e.target;
                                  getDocumentInfo(value, 'Sender');
                                  setDocumentSender(e.target.value);
                                  field.onBlur(field.onChange(value));
                                }}
                                disabled={
                                  !!isSearching ||
                                  !searchDateFrom ||
                                  !searchDateTo ||
                                  !viewDocumentSender
                                }
                              />
                            )}
                          />

                          <Controller
                            name="searchNameSender"
                            defaultValue=""
                            control={control}
                            render={({ field }) => (
                              <TextField
                                name="searchNameSender"
                                label="Razão Social/Nome Remetente"
                                {...field}
                                disabled
                                style={{ width: '100%' }}
                                error={!!errors.searchNameSender}
                                helperText={errors.searchNameSender?.message}
                              />
                            )}
                          />
                        </Stack>
                      </>
                    )}
                    <Stack
                      direction="row"
                      spacing={2}
                      style={{ justifyContent: 'space-between' }}
                    >
                      <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        disabled={!!isSubmitting || !!isSearching}
                        onClick={handleRedirectToMyAccount}
                      >
                        Voltar
                      </Button>
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        loading={!!isSubmitting}
                        disabled={!!isSubmitting || !!isSearching}
                      >
                        Pesquisar
                      </LoadingButton>
                    </Stack>
                  </Stack>
                </Stack>
              </Paper>
            </form>

            <SearchResult />

            <Paper
              elevation={2}
              style={{
                marginTop: 16,
                padding: '20px 16px 16px'
              }}
            >
              <Title style={{ marginBottom: 16 }}>Legenda</Title>
              <Stack spacing={2}>
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ alignItems: 'stretch' }}
                >
                  <div
                    style={{
                      backgroundColor: '#f3cccc', // #f38b8b
                      border: '1px solid #000',
                      width: '64px',
                      minWidth: '64px'
                    }}
                  />
                  <span style={{ fontSize: '14px' }}>
                    Solicitação aguardando envio de documentação
                  </span>
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ alignItems: 'stretch' }}
                >
                  <div
                    style={{
                      backgroundColor: '#f1e6a9', // #f0dc73
                      border: '1px solid #000',
                      width: '64px',
                      minWidth: '64px'
                    }}
                  />
                  <span style={{ fontSize: '14px' }}>
                    Solicitação em análise interna pela Braspress
                  </span>
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ alignItems: 'stretch' }}
                >
                  <div
                    style={{
                      backgroundColor: '#c4f0b6', // #69b94f
                      border: '1px solid #000',
                      width: '64px',
                      minWidth: '64px'
                    }}
                  />
                  <span style={{ fontSize: '14px' }}>
                    Solicitação liberada para impressão de etiqueta
                  </span>
                </Stack>
              </Stack>
            </Paper>
          </Stack>
        </Content>
      </Container>
      {openedModal === 'modalDownloadDocuments' && <ModalDownloadDocuments />}
      {openedModal === 'modalDownloadInvoices' && <ModalDownloadInvoices />}
      {openedModal === 'modalUploadDocuments' && <ModalUploadDocuments />}
      {openedModal === 'modalUploadInvoices' && <ModalUploadInvoices />}
      {openedModal === 'modalPrintTag' && <ModalPrintTag />}
      {openedModal === 'modalExtend' && <ModalExtend />}
      {openedModal === 'modalExtendPickup' && <ModalExtendPickup />}
      {openedModal === 'modalExtendMultiple' && <ModalExtendMultiple />}
      {openedModal === 'modalChooseExtensionMethod' && (
        <ModalChooseExtensionMethod />
      )}
      {openedModal === 'modalCancel' && <ModalCancel />}
      {openedModal === 'modalCancelPickup' && <ModalCancelPickup />}
      {openedModal === 'modalCancelMultiple' && <ModalCancelMultiple />}
      {openedModal === 'modalChooseCancelMethod' && <ModalChooseCancelMethod />}
      {openedModal === 'modalLoading' && <ModalLoading />}
    </SearchMyCollectionsContext.Provider>
  );
};

export default SearchMyCollections;
